<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      md4
    >
      <v-text-field
        v-model="name"
        :disabled="disableName()"
        :label="$t('Name')"
        outline
        class="mx-1"
      />
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-combobox
        v-model="options"
        :label="$t('Options')"
        append-icon
        return-object
        multiple
        small-chips
        deletable-chips
        outline
      />
    </v-flex>
    <v-flex
      xs12
      md2
    >
      <v-btn
        :disabled="disableCreation()"
        icon
        color="success"
        @click="create"
      >
        <v-icon>check</v-icon>
      </v-btn>
      <v-btn
        :disabled="language && !language.default"
        icon
        color="error"
        @click="remove"
      >
        <v-icon v-if="!isNew">delete</v-icon>
        <v-icon v-else>close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import randomstr from 'randomstring'

export default {
  name: 'ProductVariant',

  props: {
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          key: null,
          name: '',
          options: []
        }
      }
    },
    hideButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    isNew: {
      required: false,
      type: Boolean,
      default: false
    },
    language: {
      required: false,
      type: Object,
      default: null
    }
  },

  data () {
    return {
      variant: {
        key: '',
        name: '',
        options: []
      },
      isCreated: false
    }
  },

  computed: {
    name: {
      get () {
        return this.variant.name
      },
      set (value) {
        this.variant.name = value
        this.$emit('change', this.variant)
      }
    },
    options: {
      get () {
        return this.variant.options
      },
      set (value) {
        this.variant.options = value
        this.$emit('change', this.variant)
      }
    }
  },

  created () {
    this.variant.key = this.value.key || randomstr.generate(16)
    this.variant.name = this.value.name
    this.variant.options = this.value.options
  },

  methods: {
    disableField () {
      return this.value.key === null && !this.isNew
    },

    disableCreation () {
      if (!this.isNew) {
        return this.isCreated || this.value.key !== null
      }

      return this.name === '' || this.options.length === 0
    },

    disableName () {
      return !this.isNew && !!this.value.key && (this.language && this.language.default)
    },

    create () {
      this.$emit('created', this.variant)
      this.isCreated = true
    },

    async remove () {
      if (!this.isNew && !await this.$root.$confirm(this.$t('Product Option Removal'),
        this.$t('This operation will regenerate all variants. Do you want to continue?'), { color: 'red' })) {
        return
      }

      this.$emit('removed', this.variant.key)
    }
  }
}
</script>
